'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".GiftTrackingMessage-module_container__GEall{align-items:center;display:flex}.GiftTrackingMessage-module_containerPortrait__wgaxI{flex-direction:column;justify-content:center;padding:1.5rem 1.5rem 2rem}.GiftTrackingMessage-module_containerLandscape__CfCNi{flex-direction:row;justify-content:flex-start;padding:1.5rem}";
var styles = {"container":"GiftTrackingMessage-module_container__GEall","containerPortrait":"GiftTrackingMessage-module_containerPortrait__wgaxI GiftTrackingMessage-module_container__GEall","containerLandscape":"GiftTrackingMessage-module_containerLandscape__CfCNi GiftTrackingMessage-module_container__GEall"};
styleInject["default"](css_248z, 'c41677ff-58de-4e72-8473-748e08dbaf4f');

exports["default"] = styles;
